import React from 'react'
import styles from './styles.module.scss'

const InfoBlockMirea = ({ watchForm }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.leftSide_wrap}>
        <div className={styles.leftSide}>
          <p className={styles.title}>Программа РТУ МИРЭА</p>
        </div>
      </div>

      <div className={styles.rightSide}>
        <div className={styles.rightSide_wrap}>
          <p className={styles.text}>Mabstudy</p>
          <p className={styles.subtext}>Mabstudy — образовательный проект Российского технологического университета МИРЭА и Generium</p>
          <button onClick={watchForm}>
            Подать заявку <span>&rarr;</span>
          </button>
        </div>
      </div>
    </div>
  )
}

export default InfoBlockMirea
